import { atom, useRecoilState } from 'recoil';

interface IRecoilDrawerStore {
  isRecoilDrawerOpen: boolean;
  setIsReoilDrawerOpen: (isOpen: boolean) => void;
}

const isRecoilDrawerOpenAtom = atom<boolean>({
  key: 'is-recoil-drawer-open',
  default: false,
});

const useRecoilDebuggerStore = (): IRecoilDrawerStore => {
  const [isRecoilDrawerOpen, setIsReoilDrawerOpen] = useRecoilState(
    isRecoilDrawerOpenAtom,
  );

  return {
    isRecoilDrawerOpen,
    setIsReoilDrawerOpen,
  };
};

export default useRecoilDebuggerStore;
